<template>
  <div
    :id="name"
    :class="[slideDirection, customClass]"
    class="modal slide-modal js-slide-modal fade"
    :data-bs-backdrop="backdrop"
    :aria-labelledby="name"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div v-if="hasHeader" class="modal-header">
          <slot name="header" />
        </div>
        <div class="modal-body">
          <slot></slot>
        </div>
        <div v-if="hasFooter" class="modal-footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  computed,
  defineComponent,
  onMounted,
  ref,
  toRef,
  useStore
} from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    name: {
      type: String,
      default: 'sideModal'
    },
    customClass: {
      type: String,
      default: ''
    },
    backdrop: {
      type: String,
      default: 'true'
    },
    slideDirection: {
      type: String,
      default: 'right' // or 'left'
    }
  },
  setup(props, context) {
    const store = useStore()

    const hasHeader = computed(() => context.slots.header)
    const hasFooter = computed(() => context.slots.footer)
    const globalMessage = computed(() => store.state.globalMessage)

    const modal = ref({})

    const name = toRef(props, 'name')
    onMounted(() => {
      const Modal = require('bootstrap').Modal
      const modalEl = document.querySelector('#' + name.value)
      modal.value = new Modal(modalEl)

      modalEl.addEventListener('show.bs.modal', function(e) {
        context.emit('open', e)
      })
      modalEl.addEventListener('shown.bs.modal', function(e) {
        context.emit('opened', e)
      })
      modalEl.addEventListener('hide.bs.modal', function(e) {
        context.emit('close', e)
      })
      modalEl.addEventListener('hidden.bs.modal', function(e) {
        context.emit('closed', e)
      })
    })

    function show() {
      modal.value.show()
    }

    function hide() {
      modal.value.hide()
    }

    function toggle() {
      modal.value.toggle()
    }

    return {
      hasHeader,
      hasFooter,
      globalMessage,

      show,
      hide,
      toggle
    }
  }
})
</script>
